"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityShiftListItemDto = instanceOfFacilityShiftListItemDto;
exports.FacilityShiftListItemDtoFromJSON = FacilityShiftListItemDtoFromJSON;
exports.FacilityShiftListItemDtoFromJSONTyped = FacilityShiftListItemDtoFromJSONTyped;
exports.FacilityShiftListItemDtoToJSON = FacilityShiftListItemDtoToJSON;
exports.FacilityShiftListItemDtoToJSONTyped = FacilityShiftListItemDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const ShiftTimeWorkedDto_1 = require("./ShiftTimeWorkedDto");
const StipendDto_1 = require("./StipendDto");
const OnCallShiftDto_1 = require("./OnCallShiftDto");
const ShiftCancellationReason_1 = require("./ShiftCancellationReason");
const NurseProfileDto_1 = require("./NurseProfileDto");
const ProfileNameDto_1 = require("./ProfileNameDto");
const FacilityDto_1 = require("./FacilityDto");
const ShiftType_1 = require("./ShiftType");
const ShiftStatus_1 = require("./ShiftStatus");
const ShiftTime_1 = require("./ShiftTime");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the FacilityShiftListItemDto interface.
 */
function instanceOfFacilityShiftListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('shiftTime' in value) || value['shiftTime'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('specialty' in value) || value['specialty'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('employerFeePct' in value) || value['employerFeePct'] === undefined)
        return false;
    if (!('platformFeePct' in value) || value['platformFeePct'] === undefined)
        return false;
    if (!('isClaimable' in value) || value['isClaimable'] === undefined)
        return false;
    if (!('skippedMealBreak' in value) || value['skippedMealBreak'] === undefined)
        return false;
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('lastEditedAt' in value) || value['lastEditedAt'] === undefined)
        return false;
    if (!('proposalsFromNursesCount' in value) || value['proposalsFromNursesCount'] === undefined)
        return false;
    if (!('postedBy' in value) || value['postedBy'] === undefined)
        return false;
    if (!('cancellationDate' in value) || value['cancellationDate'] === undefined)
        return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined)
        return false;
    if (!('cancellationComment' in value) || value['cancellationComment'] === undefined)
        return false;
    if (!('canceledByProfile' in value) || value['canceledByProfile'] === undefined)
        return false;
    if (!('lastEditedByProfile' in value) || value['lastEditedByProfile'] === undefined)
        return false;
    if (!('requestedNurses' in value) || value['requestedNurses'] === undefined)
        return false;
    if (!('requestedNurseProfiles' in value) || value['requestedNurseProfiles'] === undefined)
        return false;
    return true;
}
function FacilityShiftListItemDtoFromJSON(json) {
    return FacilityShiftListItemDtoFromJSONTyped(json, false);
}
function FacilityShiftListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'facilityId': json['facilityId'],
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'nurseProfile': json['nurseProfile'] == null ? undefined : (0, NurseProfileDto_1.NurseProfileDtoFromJSON)(json['nurseProfile']),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'shiftTime': (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'specialtyCode': json['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'minutesWorked': json['minutesWorked'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': (0, ShiftStatus_1.ShiftStatusFromJSON)(json['status']),
        'submittedTimeAt': json['submittedTimeAt'] == null ? undefined : (new Date(json['submittedTimeAt'])),
        'employerFeePct': json['employerFeePct'],
        'platformFeePct': json['platformFeePct'],
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftDto_1.OnCallShiftDtoFromJSON)(json['onCallShift']),
        'isClaimable': json['isClaimable'],
        'skippedMealBreak': json['skippedMealBreak'],
        'skippedMealBreakComment': json['skippedMealBreakComment'] == null ? undefined : json['skippedMealBreakComment'],
        'didNotWork': json['didNotWork'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'lastEditedAt': (new Date(json['lastEditedAt'])),
        'timeWorked': json['timeWorked'] == null ? undefined : (json['timeWorked'].map(ShiftTimeWorkedDto_1.ShiftTimeWorkedDtoFromJSON)),
        'matchesCount': json['matchesCount'] == null ? undefined : json['matchesCount'],
        'proposalsFromNursesCount': json['proposalsFromNursesCount'],
        'postedBy': json['postedBy'],
        'cancellationDate': (json['cancellationDate'] == null ? null : new Date(json['cancellationDate'])),
        'cancellationReason': (0, ShiftCancellationReason_1.ShiftCancellationReasonFromJSON)(json['cancellationReason']),
        'cancellationComment': json['cancellationComment'],
        'canceledByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['canceledByProfile']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['lastEditedByProfile']),
        'requestedNurses': json['requestedNurses'],
        'requestedNurseProfiles': (json['requestedNurseProfiles'].map(ProfileNameDto_1.ProfileNameDtoFromJSON)),
        'hasExpiredCredentialsInGracePeriod': json['hasExpiredCredentialsInGracePeriod'] == null ? undefined : json['hasExpiredCredentialsInGracePeriod'],
    };
}
function FacilityShiftListItemDtoToJSON(json) {
    return FacilityShiftListItemDtoToJSONTyped(json, false);
}
function FacilityShiftListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'facilityId': value['facilityId'],
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoToJSON)(value['nurseProfile']),
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'minutesWorked': value['minutesWorked'],
        'description': value['description'],
        'status': (0, ShiftStatus_1.ShiftStatusToJSON)(value['status']),
        'submittedTimeAt': value['submittedTimeAt'] == null ? undefined : (value['submittedTimeAt'].toISOString()),
        'employerFeePct': value['employerFeePct'],
        'platformFeePct': value['platformFeePct'],
        'onCallShift': (0, OnCallShiftDto_1.OnCallShiftDtoToJSON)(value['onCallShift']),
        'isClaimable': value['isClaimable'],
        'skippedMealBreak': value['skippedMealBreak'],
        'skippedMealBreakComment': value['skippedMealBreakComment'],
        'didNotWork': value['didNotWork'],
        'isSearchable': value['isSearchable'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'lastEditedAt': ((value['lastEditedAt']).toISOString()),
        'timeWorked': value['timeWorked'] == null ? undefined : (value['timeWorked'].map(ShiftTimeWorkedDto_1.ShiftTimeWorkedDtoToJSON)),
        'matchesCount': value['matchesCount'],
        'proposalsFromNursesCount': value['proposalsFromNursesCount'],
        'postedBy': value['postedBy'],
        'cancellationDate': (value['cancellationDate'] == null ? null : value['cancellationDate'].toISOString()),
        'cancellationReason': (0, ShiftCancellationReason_1.ShiftCancellationReasonToJSON)(value['cancellationReason']),
        'cancellationComment': value['cancellationComment'],
        'canceledByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['canceledByProfile']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['lastEditedByProfile']),
        'requestedNurses': value['requestedNurses'],
        'requestedNurseProfiles': (value['requestedNurseProfiles'].map(ProfileNameDto_1.ProfileNameDtoToJSON)),
        'hasExpiredCredentialsInGracePeriod': value['hasExpiredCredentialsInGracePeriod'],
    };
}
//# sourceMappingURL=FacilityShiftListItemDto.js.map